module.exports = __webpack_public_path__ + "static/media/998032.5f12440f.jpg";